/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";
import values from "lodash/fp/values";
import { initReactI18next } from "react-i18next";

import namespaces from "../../config/translations.config";
import { TranslationLang } from "~/constants";

// eslint-disable-next-line @typescript-eslint/no-floating-promises,import/no-named-as-default-member
i18n
  .use(
    resourcesToBackend((language, namespace, callback) => {
      const importRes = namespaces.includes(namespace)
        ? import(`../features/${namespace}/locales/${language}.json`)
        : import(`../locales/${language}.json`);

      importRes
        .then((resources) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          callback(null, resources);
        })
        .catch((error) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          callback(error, null);
        });
    }),
  )
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: TranslationLang.EN,
    supportedLngs: values(TranslationLang),
    ns: ["common", ...namespaces],
    defaultNS: "common",
    interpolation: {
      escapeValue: false, // React escapes values
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
